// ----------------------------------------------------------------------

export function localStorageAvailable() {
  try {
    const key =
      '547t89dfgkabvxziuDEH&/()yn34nio-534t35nufiAOJKIOBvfedrsf79u486g55t%/(yasd-217843ng';
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
}

export function localStorageGetItem(key: string, defaultValue = '') {
  const storageAvailable = localStorageAvailable();

  let value;

  if (storageAvailable) {
    value = localStorage.getItem(key) || defaultValue;
  }

  return value;
}
